<template>
  <div
    v-if="data.input"
    ref="formWrapper"
    class="input-component chat-rating">
    <v-container>
      <v-layout class="justify-center">
        <v-rating
          v-model="data.value"
          background-color="orange lighten-3"
          color="orange"
          :length="data.length"
          :readonly="data.readonly"
          @input="save(data.value)"
          :dense="isMobile"
          :size="size" />
      </v-layout>
    </v-container>
  </div>
  <message
    v-else
    :record="record" />
</template>

<script>
  import Message from './Message'
  import chatUiMixin from '@/mixins/chat-ui'
  import validate from '@/mixins/validate'

  export default {
    components: { Message },
    mixins: [chatUiMixin, validate],
    data () {
      return {
        rating: 0,
        valid: true
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.smAndDown
      },
      size () {
        return this.isMobile ? 35 : 45
      },
      data () {
        return this.record.data
      }
    },
    mounted () {
      this.startAnimation()
    },
    methods: {
      save (value) {
        let callback = () => {
          let option = {
            slug: this.slug,
            value,
            topic: this.$route.params.caseId
          }
          this.$emit('send', option)
        }

        this.endAnimation(callback)
      }
    }
  }
</script>

<style lang="sass">
  @import '../../assets/style/variables'

  .chat-rating
    max-width: 100%
    min-height: 100%
    margin: 0 auto

    .v-rating
      margin-top: 7px

  @media screen and (max-width: $max-mobile)
    .chat-rating
      .v-rating
        margin-top: 17px
</style>
